import { 
  scrollControlFunc,
  topMain1,
  torefarmMain ,
  diningMain ,
  livingMain ,
 } from './index';

const loadFunc = (() => {


  let loadWrap = document.getElementById('jsLoadWrap');
  scrollControlFunc.noScroll();

  const startFunc = () => {
    loadWrap.classList.add('no-act');
    scrollControlFunc.returnScroll();
    topMain1()
    torefarmMain()
    diningMain()
    livingMain()
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(startFunc, 100)
  });

  
})();
export default loadFunc;